import { ErrorIcon, PauseIcon, PlayIcon } from "@/Icons";
import { cx } from "@/utils";
import Clickable, { ClickableProps } from "@components/Clickable";
import PlayingAnimated from "@components/PlayingAnimated";
import SpinnerAnimated from "@components/SpinnerAnimated";
import Tooltip from "@components/Tooltip";

import styles from "./PlayButton.module.css";

export type PlayButtonProps = {
  loading?: boolean;
  error?: boolean;
  playing?: boolean;
  monochrome?: boolean;
} & ClickableProps;

const PlayButton: React.FunctionComponent<PlayButtonProps> = ({
  className,
  loading = false,
  disabled,
  error = false,
  playing = false,
  monochrome = false,
  ...rest
}) => (
  <Clickable
    data-testid="play-link"
    disabled={disabled}
    className={cx(
      styles.root,
      {
        [styles.hover]: !error && !loading && !disabled,
        [styles.loading]: loading,
        [styles.playing]: playing,
        [styles.errored]: error,
        [styles.monochrome]: monochrome,
      },
      className
    )}
    {...rest}
  >
    <PlayIcon
      className={cx({ [styles.visible]: !loading && !playing && !error })}
    />

    <PlayingAnimated
      className={cx(styles.animation, {
        [styles.visible]: playing && !loading && !error,
      })}
    />
    <PauseIcon
      className={cx(styles.pause, {
        [styles.visible]: playing && !loading && !error,
      })}
    />
    <SpinnerAnimated className={cx({ [styles.visible]: loading })} />
    {error && (
      <Tooltip content={L.MENTIONS_PLAYER_GENERIC_ERROR}>
        <div>
          <ErrorIcon className={cx({ [styles.visible]: error })} />
        </div>
      </Tooltip>
    )}
  </Clickable>
);

export default PlayButton;
